import { render, staticRenderFns } from "./Prop.vue?vue&type=template&id=dc342932&"
import script from "./Prop.vue?vue&type=script&lang=js&"
export * from "./Prop.vue?vue&type=script&lang=js&"
import style0 from "./Prop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports